<div *ngIf="url$ | async as url" class="wrapper">
  <iframe frameborder="0" allowfullscreen webkitallowfullscreen mozallowfullscreen [src]="url | safeUrl"></iframe>
</div>
